import api from './api';

/**
 * Item service for managing inventory items
 */

export const itemService = {
  /**
   * Get all items, optionally filtered by category and search
   */
  getAll: async (categoryId = null, skip = 0, limit = 50, search = null) => {
    const params = { skip, limit };
    if (categoryId) {
      params.category_id = categoryId;
    }
    if (search) {
      params.search = search;
    }
    const response = await api.get('/items', { params });
    
    // Parse pagination from headers
    const total = parseInt(response.headers['x-total-count'] || '0');
    
    return {
      data: response.data,
      total
    };
  },

  /**
   * Get a single item by ID
   */
  getById: async (itemId) => {
    const response = await api.get(`/items/${itemId}`);
    return response.data;
  },

  /**
   * Create a new item
   */
  create: async (itemData) => {
    const response = await api.post('/items', itemData);
    return response.data;
  },

  /**
   * Update an existing item
   */
  update: async (itemId, itemData) => {
    const response = await api.put(`/items/${itemId}`, itemData);
    return response.data;
  },

  /**
   * Delete an item
   */
  delete: async (itemId) => {
    await api.delete(`/items/${itemId}`);
  }
};
